module.exports = __webpack_public_path__ + "img/shangchuanwenjian.2dd88e48.png";